import { render, staticRenderFns } from "./CollectionAccessForm.vue?vue&type=template&id=75fbbe30&scoped=true&"
import script from "./CollectionAccessForm.vue?vue&type=script&lang=js&"
export * from "./CollectionAccessForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAccessForm.vue?vue&type=style&index=0&id=75fbbe30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fbbe30",
  null
  
)

export default component.exports